/* eslint-disable import/no-cycle */
/* eslint-disable func-names */
import {
	all, call, fork, put, takeLatest,
} from 'redux-saga/effects';
import { ALERTAS_ROUTE } from '../../../constants';
import api from '../../../services/api';
import { Types } from '../../ducks/alertas/alerta';
import executeAction from '../comum/executeAction';

/** SAGAS */
function* asyncAlertaBuscar(action) {
	yield executeAction(function* () {
		const { alertaId, callback } = action;

		const { data } = yield call(api.get, ALERTAS_ROUTE.FIND_BY_ID.replace('{alertaId}', alertaId));

		yield put({
			type: Types.ALERTA_BUSCAR_REDUCER,
			alerta: data,
		});

		callback(data);
	}, Types.ALERTA_BUSCAR);
}

function* asyncAlertaCadastrar(action) {
	yield executeAction(function* () {
		const { alerta, callback } = action;

		const { data } = yield call(api.post, ALERTAS_ROUTE.CREATE, alerta);

		yield put({
			type: Types.ALERTA_CADASTRAR_REDUCER,
			alerta: data,
		});

		callback(data);
	}, Types.ALERTA_CADASTRAR);
}

function* asyncAlertaAlterarStatus(action) {
	yield executeAction(function* () {
		const { alerta, callback } = action;
		const { data } = yield call(api.post, ALERTAS_ROUTE.CHANGE_STATUS, alerta);

		yield put({
			type: Types.ALERTA_ALTERAR_STATUS_REDUCER,
			data,
		});

		callback();
	}, Types.ALERTA_ALTERAR_STATUS);
}

function* asyncAlertaFiltro(action) {
	yield executeAction(function* () {
		const { filtro } = action;

		if (!filtro.pagina || filtro.pagina < 0) filtro.pagina = 0;

		const { data } = yield call(api.post, ALERTAS_ROUTE.FIND_BY_FILTER, filtro);

		yield put({
			type: Types.ALERTA_FILTRO_REDUCER,
			lista: data,
		});
	}, Types.ALERTA_FILTRO);
}

function* takeAlertaBuscar() {
	yield takeLatest(Types.ALERTA_BUSCAR, asyncAlertaBuscar);
}

function* takeAlertaCadastrar() {
	yield takeLatest(Types.ALERTA_CADASTRAR, asyncAlertaCadastrar);
}

function* takeAlertaAlterarStatus() {
	yield takeLatest(Types.ALERTA_ALTERAR_STATUS, asyncAlertaAlterarStatus);
}

function* takeAlertaFiltro() {
	yield takeLatest(Types.ALERTA_FILTRO, asyncAlertaFiltro);
}

export default function* root() {
	yield all([
		fork(takeAlertaBuscar),
		fork(takeAlertaCadastrar),
		fork(takeAlertaAlterarStatus),
		fork(takeAlertaFiltro),
	]);
}
